// アプリインポート関連のハンドラー
import { parseTreeOutput } from '../components/app-importer.js';
import { getImportedApps, setImportedApps } from '../state/app-state.js';
import { t } from '../utils/i18n.js';
import { renderUI } from './ui-handlers.js';
import { updateCode } from './code-handlers.js';

/**
 * Treeコマンドの出力をインポート
 */
export function importTreeOutput(): void {
    const treeInput = document.getElementById('treeInput') as HTMLTextAreaElement | null;
    const importStatus = document.getElementById('importStatus');
    if (!treeInput || !importStatus) return;
    
    const treeText = treeInput.value.trim();
    if (!treeText) {
        importStatus.textContent = 'Treeコマンドの出力を入力してください';
        importStatus.className = 'mt-2 text-xs text-red-400';
        return;
    }
    
    try {
        const result = parseTreeOutput(treeText);
        setImportedApps(result.apps);
        const apps = getImportedApps();
        
        if (apps.length === 0) {
            importStatus.textContent = '.exeファイルが見つかりませんでした';
            importStatus.className = 'mt-2 text-xs text-yellow-400';
        } else {
            importStatus.textContent = `${apps.length}個のアプリケーションを検出しました（インストーラーパス: ${result.installerPath}）`;
            importStatus.className = 'mt-2 text-xs text-green-400';
            
            // UIを再生成
            renderUI();
            updateCode();
        }
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        importStatus.textContent = t('importError', { error: errorMessage });
        importStatus.className = 'mt-2 text-xs text-red-400';
    }
}

/**
 * アプリケーションリストをクリア
 */
export function clearApps(): void {
    setImportedApps([]);
    const treeInput = document.getElementById('treeInput') as HTMLTextAreaElement | null;
    const importStatus = document.getElementById('importStatus');
    if (treeInput) treeInput.value = '';
    if (importStatus) importStatus.textContent = '';
    renderUI();
    updateCode();
}

